import React from 'react';
import styles from './SavedList.module.scss';
import { useNavigate } from 'react-router-dom';
import Icon from '../Icon/Icon';
import ListingNewsSkeleton from '../../containers/Library/ListingNewsSkeleton';

const SavedList = ({ title, items, type, loading }) => {
  const navigate = useNavigate();
  const emptyText = type === 'news' ? 'No saved news yet.' : 'No saved creations yet.';

  const handleViewAll = () => {
    if (type === 'news') navigate('/library/saved-news');
    else if (type === 'creations') navigate('/library/saved-creations');
    else if (type === 'recently-purchased') navigate('/library/recently-purchased');
    else if (type === 'my') navigate('/library/recently-added');
  };

  const handleItemClick = (item) => {
    if (type === 'news') {
      const newsId = item.id || item.news_id;
      if (newsId) navigate(`/news/${newsId}`);
    } else {
      // For creations, recently-purchased, and my types
      const creationId =
        item.id ||
        item.creation_id ||
        item.creations?.id ||
        item.creation?.id ||
        item.creation?.creation_id;
      if (creationId) navigate(`/creations/${creationId}`);
    }
  };
  return (
    <div className={styles.savedSection}>
      <div className={styles.sectionHeader}>
        <h2 className={`d-flex aic ${styles.headerClickable}`} onClick={handleViewAll}>{title}<Icon alias="chevron-right" className="ml-8" width={20} stroke="#FF3232" /></h2>
      </div>
      {loading ? (<div className={`${styles.cardList}`}>
        {[1, 2, 3, 4].map((item) => <ListingNewsSkeleton key={item}
          height={type === 'news' ? '104px' : "112px"}
          width={type === 'news' ? '104px' : "171px"}
        />)}
      </div>) :

        items && items.length > 0 ? (
          <div className={`${styles.cardList}`}>
            {items.map((item, idx) => (
              <div
                className={`${styles.card} ${type === 'news' ? styles.cardNews : ''}`}
                key={idx}
                onClick={() => handleItemClick(item)}
                style={{ cursor: 'pointer' }}
              >
                <img
                  src={
                    item.thumbnailUrl ||
                    item.thumbnail_url ||
                    item.imageUrl ||
                    item.image ||
                    item.media_url ||
                    item.media?.media_url ||
                    item.creations?.thumbnail_url ||
                    item.creations?.thumbnailUrl ||
                    item.creations?.imageUrl ||
                    item.creation?.thumbnail_url
                  }
                  alt={item.title || item.creations?.title || item.creation?.title}
                  className={`${type === 'news' ? styles.cardImageNews : styles.cardImage}`}
                />
                <div className={styles.cardTitle}>
                  {item.title || item.creations?.title || item.creation?.title}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className={styles.emptyState}>
            <Icon alias={type === 'news' ? 'news' : 'library_v2'} width={40} height={40} color="#d9d9d9" />
            <div className={styles.emptyText}>{emptyText}</div>
          </div>
        )}

    </div>
  );
};

export default SavedList; 